import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MasterProductCounterPageRoutingModule } from './master-product-counter-routing.module';

import { MasterProductCounterPage } from './master-product-counter.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MasterProductCounterPageRoutingModule,
    NgxDatatableModule,
    IonicSelectableModule
  ],
  declarations: [MasterProductCounterPage]
})
export class MasterProductCounterPageModule {}
